var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonPlayClasses,attrs:{"aria-label":_vm.ariaLabel,"tabindex":"0"},on:{"click":_vm.onPlay,"keydown":_vm.onPlaySpace}},[_c('Icon',{attrs:{"name":"audio","size":_vm.size,"color":_vm.colorIcon,"focusable":"false"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }